import { useOktaAuth } from '@okta/okta-react';
import React from 'react';

import { Button } from './Button';

const Logout = () => {
  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    await oktaAuth.signOut();
  };

  return (
    <Button type="button" variant="primary" onClick={logout}>
      Logout
    </Button>
  );
};

export default Logout;
